module.exports = __webpack_public_path__ + "media/images/athletes/2172-aa40ec631b268a3ca7756db5d438c1c1.png";